export default class Thumbnail {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        try {
            this.adaptThumbnail();

            const observer = new MutationObserver(() => {this.adaptThumbnail()});

            if(document.getElementsByClassName('search-page')[0]) { //include recherche
                const mapobserver = new MutationObserver(() => {this.adaptThumbnail()});
                mapobserver.observe(document.querySelector('#search-wrap'), { attributes: true, childList: true, subtree: true });
                observer.observe(document.querySelector('#data-wrapper'), { attributes: true, childList: true, subtree: true });
            } else {
                if (document.querySelector('.event-card-wrapper')) {
                    observer.observe(document.querySelector('.event-card-wrapper'), { attributes: true, childList: true, subtree: true });
                }
                if (document.querySelector('#data-soon-events-wrapper')) {
                    observer.observe(document.querySelector('#data-soon-events-wrapper'), { attributes: true, childList: true, subtree: true });
                }
                if (document.querySelector('.double-line')) {
                    this.makeDoubleLine();
                }
            }

            window.addEventListener('resize', () => {
                this.adaptThumbnail();
            });

            let cardWrapper = document.getElementsByClassName('event-card-wrapper');
            for (let i = 0; i < cardWrapper.length; i++) {
                cardWrapper[i].style.opacity = 1;
            }
        } catch {
            //no need to do something, just prevent js crash
        }
    }

    adaptThumbnail() {
        if(document.getElementsByClassName('home-page')[0]) { //not include recherche (so home page)
            if(!window.matchMedia('(max-width: 950px)').matches) {
                this.makeThumbnailsResponsive(true);
            } else {
                this.makeThumbnailsResponsive(false);
            }
        } else {
            this.makeThumbnailsResponsiveSearchPage();
        }
    }

    makeThumbnailsResponsiveSearchPage() {
        let eventCards = document.querySelectorAll('.event-card');

        for(let eventCard of eventCards) {
            let thumbnail = eventCard.querySelector('.thumbnail');
            let thumbnail_map = eventCard.querySelector('.thumbnail-map');

            let width = eventCard.clientWidth;
            //we don't apply this style to cards in the map
            if(!eventCard.classList.contains('map-card')){
                let height = width / 2;
                thumbnail.style.height = height+"px";
                thumbnail.style.width = width+"px";
            } else {
              thumbnail_map.style.height = "auto";
            }
        }
    }

    /**
     *
     * @param responsivity
     */
    makeThumbnailsResponsive(responsivity = true) {
        let eventCards = document.querySelectorAll('.event-card');

        if(responsivity) {
            for(let eventCard of eventCards) {
                let thumbnail = eventCard.querySelector('.thumbnail');

                let width = (eventCard.parentElement.clientWidth / 4) - (22 * 3 / 4);
                let height = width / 2;

                thumbnail.style.width = width+"px";
                thumbnail.style.height = height+"px";
                eventCard.style.width = width+"px";

            }

        } else {
            for(let eventCard of eventCards) {
                let thumbnail = eventCard.querySelector('.thumbnail');

                thumbnail.style.width = '';
                thumbnail.style.height = '';
                eventCard.style.width = '';
            }
        }
    }

    /**
     * Check if .double-line section count more than 4 events
     */
    makeDoubleLine() {
        let eventCardsWrapper = document.querySelector('.double-line');

        if (window.matchMedia('(max-width: 950px)').matches && eventCardsWrapper.children.length <= 4) {
            eventCardsWrapper.style.display = 'flex';
            eventCardsWrapper.style.flexWrap = 'inherit';
        }
    }
}
